export const apiAuth = '/api/auth';
export const apiGraphQL = '/api/graphql';
export const apiRPC = '/api/trpc';
